var _linearGradient, _linearGradient2, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 48,
    y1: 48.0432,
    y2: 48.0432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fffb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fffb1",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    x2: 24,
    y1: 0,
    y2: 48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcae33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcae33",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48 23.9986c.0003 4.7469-1.4071 9.3872-4.0442 13.3342-2.637 3.947-6.3853 7.0234-10.7708 8.84-4.3854 1.8167-9.2112 2.2921-13.8668 1.3661-4.6557-.926-8.9322-3.2118-12.28875-6.5684-3.35655-3.3565-5.64235-7.633-6.568353-12.2887-.926001-4.6556-.4506069-9.4814 1.366063-13.8668 1.81668-4.3855 4.89303-8.1338 8.84004-10.77084 3.947-2.63705 8.5873-4.04443217 13.3342-4.04415996 3.1515 0 6.2722.62074596 9.1839 1.82678996 2.9116 1.20604 5.5572 2.97376 7.7857 5.20224 2.2284 2.22848 3.9962 4.87407 5.2022 7.78567 1.2061 2.9117 1.8268 6.0324 1.8268 9.1839zm-23.9986-7.8298c-11.5981 0-20.99967 7.8298-20.99967 7.8298s9.40157 7.8298 20.99967 7.8298 20.9983-7.8298 20.9983-7.8298-9.4016-7.8298-20.9983-7.8298z",
    fill: "#686876"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m48 23.9986c.0003 4.7469-1.4071 9.3872-4.0442 13.3342-2.637 3.947-6.3853 7.0234-10.7708 8.84-4.3854 1.8167-9.2112 2.2921-13.8668 1.3661-4.6557-.926-8.9322-3.2118-12.28875-6.5684-3.35655-3.3565-5.64235-7.633-6.568353-12.2887-.926001-4.6556-.4506069-9.4814 1.366063-13.8668 1.81668-4.3855 4.89303-8.1338 8.84004-10.77084 3.947-2.63705 8.5873-4.04443217 13.3342-4.04415996 3.1515 0 6.2722.62074596 9.1839 1.82678996 2.9116 1.20604 5.5572 2.97376 7.7857 5.20224 2.2284 2.22848 3.9962 4.87407 5.2022 7.78567 1.2061 2.9117 1.8268 6.0324 1.8268 9.1839zm-23.9986-7.8298c-11.5981 0-20.99967 7.8298-20.99967 7.8298s9.40157 7.8298 20.99967 7.8298 20.9983-7.8298 20.9983-7.8298-9.4016-7.8298-20.9983-7.8298z",
    fill: "url(#a)",
    fillOpacity: 0.33
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m48 23.9986c.0003 4.7469-1.4071 9.3872-4.0442 13.3342-2.637 3.947-6.3853 7.0234-10.7708 8.84-4.3854 1.8167-9.2112 2.2921-13.8668 1.3661-4.6557-.926-8.9322-3.2118-12.28875-6.5684-3.35655-3.3565-5.64235-7.633-6.568353-12.2887-.926001-4.6556-.4506069-9.4814 1.366063-13.8668 1.81668-4.3855 4.89303-8.1338 8.84004-10.77084 3.947-2.63705 8.5873-4.04443217 13.3342-4.04415996 3.1515 0 6.2722.62074596 9.1839 1.82678996 2.9116 1.20604 5.5572 2.97376 7.7857 5.20224 2.2284 2.22848 3.9962 4.87407 5.2022 7.78567 1.2061 2.9117 1.8268 6.0324 1.8268 9.1839zm-23.9986-7.8298c-11.5981 0-20.99967 7.8298-20.99967 7.8298s9.40157 7.8298 20.99967 7.8298 20.9983-7.8298 20.9983-7.8298-9.4016-7.8298-20.9983-7.8298z",
    fill: "url(#b)",
    fillOpacity: 0.33
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m34 19.0456c0 6.0752-7.0958 6.1687-7.0958 8.4138v.5742c0 .6004-.5264 1.0872-1.1757 1.0872h-4.4725c-.6493 0-1.1758-.4868-1.1758-1.0872v-.7846c0-3.2386 2.6553-4.5333 4.6618-5.5736 1.7206-.892 2.7752-1.4987 2.7752-2.68 0-1.5625-2.1555-2.5997-3.898-2.5997-2.2721 0-3.321.9946-4.7954 2.7154-.3975.4638-1.1228.55-1.6329.1924l-2.7262-1.9116c-.5004-.3508-.6124-1.0026-.259-1.4825 2.3149-3.1434 5.2635-4.9094 9.8543-4.9094 4.8079 0 9.94 3.4705 9.94 8.0456zm-6.3926 15.149c0 2.0983-1.846 3.8054-4.1151 3.8054s-4.1152-1.7071-4.1152-3.8054 1.8461-3.8053 4.1152-3.8053 4.1151 1.707 4.1151 3.8053z",
    fill: "#e5ecf1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/Unknown.bf0c01cbafa2128c24ad9846c479c58a.svg";
export { ForwardRef as ReactComponent };